

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

let Vue = require('vue').default;
window.Vue = Vue;
window.$ = window.jQuery = require('jquery');


require('./sentry').default;
require('./axios').default;

require('bootstrap-3-typeahead');

require('froala-editor/js/froala_editor.pkgd.min');

// Require Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css');
require('font-awesome/css/font-awesome.css');
require('froala-editor/css/froala_style.min.css');


import VueRouter from 'vue-router';
// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg';
import draggable from 'vuedraggable';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';

import ElementUI, {
    Alert,
    Aside,
    Autocomplete,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    Button,
    ButtonGroup,
    Card,
    Carousel,
    CarouselItem,
    Cascader,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Col,
    Collapse,
    CollapseItem,
    ColorPicker,
    Container,
    DatePicker,
    Dialog,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Footer,
    Form,
    FormItem,
    Header,
    Icon,
    Input,
    InputNumber,
    Loading,
    Main,
    Menu,
    MenuItem,
    MenuItemGroup,
    Message,
    MessageBox,
    Notification,
    Option,
    OptionGroup,
    Pagination,
    Popover,
    Progress,
    Radio,
    RadioButton,
    RadioGroup,
    Rate,
    Row,
    Select,
    Slider,
    Step,
    Steps,
    Submenu,
    Switch,
    Table,
    TableColumn,
    TabPane,
    Tabs,
    Tag,
    TimePicker,
    TimeSelect,
    Tooltip,
    Transfer,
    Tree,
    Upload
} from 'element-ui';

Vue.use(VueRouter);

Vue.use(VueFroala);

var ElementQueries = require('css-element-queries/src/ElementQueries');
ElementQueries.listen();

Vue.use(ElementUI, { locale });

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

let globals = {
    data: function () {
        return {
            globals: window.global_defaults
        }
    }
};
Vue.mixin(globals);

$(function() {
    Vue.component('draggable', draggable);

    Vue.mixin({
        methods: {
            money(number, digits = 2) {
                if(!number && number !== 0){
                    return null;
                }

                if (number == 999999)
                    return 'Unlimited';

                let sign = number >= 0 ? '$' : '-$';
                number = Math.abs(number);

                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'decimal',
                    maximumFractionDigits: digits,
                });
                return sign + formatter.format(number);
            },
            moneyCommas(number, digits = 2) {
                if(!number){
                    return null;
                }

                if (number == 999999)
                    return 'Unlimited';

                let sign = number >= 0 ? '$ ' : '-$ ';
                number = Math.abs(number);

                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'decimal',
                    minimumFractionDigits: digits,
                    maximumFractionDigits: digits,
                });
                return sign + formatter.format(number);
            },
            percent(val, digits = 2, isInputFraction = true) {
                if (!val)
                    return val;
                if(isInputFraction) {
                    val = val * 100;
                }
                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'decimal',
                    minimumFractionDigits: digits,
                    maximumFractionDigits: digits,
                });
                return formatter.format(val) + '%';
            },
            usNum(number){
                if(!number){
                    return null;
                }
                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'decimal',
                    maximumFractionDigits: 2,
                });
                return formatter.format(number);
            },
            csvMoney(val){
                var result = this.money(val);
                if(!result){
                    return result;
                }
                return result.replace(',', '');
            }
        }
    });

    Vue.mixin({
        methods: {
            url(text) {
                return url(text);
            },
            moment(date) {
                return moment(date);
            }
        }
    });
    Vue.component('vue-dropzone', require('vue2-dropzone').default);

    let asyncCalls = require('./mixins/asyncCalls.js');
    Vue.mixin(asyncCalls.default);

    let statusMessage = require('./mixins/statusMessage.js');
    Vue.mixin(statusMessage.default);

    require('../../../driver_engage/driverengage.js').default;
    require('../../../accounts/components.js').default;
    require('../../../budgets/components.js').default;
    require('../../../calls/components.js').default;
    require('../../../common/components.js').default;
    require('../../../clients/components.js').default;
    require('../../../delivery/components.js').default;
    require('../../../feeds/components.js').default;
    require('../../../forum/components.js').default;
    require('../../../job_board/components.js').default;
    require('../../../tracking/components.js').default;
    require('../../../multi_carrier/components.js').default;
    require('../../../driver/components.js').default;
    require('../../../hammer/components.js').default;
    require('../../../ui-backend/components.js').default;

    if ($('#app').length) {
        const app = new Vue({
            el: '#app',
            data() {
                return {
                    imageUploadUrl: window.imageUploadUrl,
                }
            },
            mounted() {
                ElementQueries.init();
            }
        });
    }

    if ($('#sysopbar').length) {
        const sysopbar = new Vue({
            el: '#sysopbar'
        });
    }
});
